import { mergeStyleSets } from "@fluentui/react";
import moment from "moment";
import { FontIcon } from "office-ui-fabric-react";
import React, { FC, useEffect, useState } from "react";
import Moment from "react-moment";
import { ActivityLog } from "../../models/ProcessFlowConfig";

type Props = {
  activityLogs: ActivityLog[];
};

const classes = mergeStyleSets({
  container: { width: "100%" },
  header: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    padding: "8px 4px",
    marginTop: 12,
    borderTop: "1px solid #E2E6E8",
    fontWeight: "bolder",
    textTransform: "capitalize"
  },
  body: {
    textAlign: "left",
    padding: "8px 4px"
  },
  timestampRow: {
    fontSize: "14px",
    textAlign: "left",
    fontWeight: 600,
    paddingTop: "5px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "flex"
  },
  time: {
    display: "inline-block",
    lineHeight: 42,
    width: "50%"
  },
  inputValue: {
    display: "flex",
    justifyContent: "space-between",
    border: "1px solid #E2E6E8",
    backgroundColor: "#FAFAFA",
    padding: 6,
    marginBottom: 4
  }
});

const StepPreviewPanel: FC<Props> = (props: Props) => {
  const [label, setLabel] = useState<string>("");
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [startLog, setStartLog] = useState<ActivityLog>();
  const [endLog, setEndLog] = useState<ActivityLog>();

  useEffect(() => {
    if (props.activityLogs.length > 0) {
      setLabel(props.activityLogs.reverse()[0].description);
      const _startLog = props.activityLogs
        .reverse()
        .filter(f => f.status === 1)[0];
      if (_startLog) {
        setStartLog(_startLog);
      }

      const _endTime = props.activityLogs
        .reverse()
        .filter(f => f.status === 2 || f.status === 3)[0];
      if (_endTime) {
        setEndLog(_endTime);
        setLabel(_endTime.description);
      } else {
        const _void = props.activityLogs.find(f => f.status === 4);
        if (_void) {
          setEndLog(_void);
          setLabel(_void.description);
        }
      }
    }
  }, [props.activityLogs]);

  return (
    <div className={classes.container}>
      <div
        className={classes.header}
        onClick={() => setShowDetails(!showDetails)}
      >
        <span>{label}</span>
        {showDetails && <FontIcon iconName="ChevronUp" />}
        {!showDetails && <FontIcon iconName="ChevronDown" />}
      </div>
      {showDetails && (
        <div className={classes.body}>
          {startLog && (
            <>
              <div className={classes.timestampRow}>
                <span className={classes.time}>
                  <FontIcon iconName="clock" />
                  &nbsp;
                  <Moment format="HH:mm - ll" local>
                    {`${moment
                      .utc(startLog.logTime)
                      .format("YYYY-MM-DD HH:mm:ss")} UTC`}
                  </Moment>
                </span>

                <span className={classes.time} style={{ textAlign: "right" }}>
                  {startLog.performedByName && (
                    <>
                      <FontIcon iconName="TemporaryUser" />
                      &nbsp;
                      {startLog.performedByName}
                    </>
                  )}
                </span>
              </div>
              <div>
                {startLog.inputValues.map(val => (
                  <div className={classes.inputValue}>
                    <span>{val.caption}</span>
                    <b>{val.value}</b>
                  </div>
                ))}
              </div>
            </>
          )}

          {endLog && (
            <>
              <div className={classes.timestampRow}>
                <span className={classes.time}>
                  <FontIcon iconName="SkypeCircleClock" />
                  &nbsp;
                  <Moment format="HH:mm - ll" local>
                    {`${moment
                      .utc(endLog.logTime)
                      .format("YYYY-MM-DD HH:mm:ss")} UTC`}
                  </Moment>
                </span>

                <span className={classes.time} style={{ textAlign: "right" }}>
                  {endLog.performedByName && (
                    <>
                      <FontIcon iconName="TemporaryUser" />
                      &nbsp;
                      {endLog.performedByName}
                    </>
                  )}
                </span>
              </div>
              <div>
                {endLog.inputValues.map(val => (
                  <div className={classes.inputValue}>
                    <span>{val.caption}</span>
                    <b>{val.value}</b>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
export default StepPreviewPanel;
